




















import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
interface System {
  value: number;
  title: string;
}
@Component
export default class Presentational extends Vue {
  public systems: System[] = [
    {
      value: 0,
      title: 'クトゥルフ神話TRPG（6th edition）',
    },
    {
      value: 1,
      title: '新クトゥルフ神話TRPG（7th edition）',
    },
  ];

  @Prop() public gamesystem!: number;

  @Emit() public update(payload: number) {}

  private get selected(): number {
    return this.gamesystem;
  }

  private set selected(payload: number) {
    this.update(payload);
  }
}
